import React, { Component } from 'react';
import './completion-report.scss';
import { ImageConstants, Constants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import HomeworkApi from '../../../apis/homework'
import Loading from '../../common/loading/loading'
import { withRouter } from 'react-router-dom';

class CompletionReport extends Component {

    state = {
        completedStudents: [
            { name: "Abhijeet Sengar", rollNumber: "01", mark: 30 },
            { name: "Shudanshu Pal", rollNumber: "02", mark: 30 },
            { name: "Sonia Pal", rollNumber: "03", mark: 30 }
        ],
        notCompletedStudents: [
            { name: "Sameer Jain", rollNumber: "04" },
            { name: "Priya kumari", rollNumber: "05" },
            { name: "Kamal De", rollNumber: "06" }
        ]
    }

    componentDidMount() {

        this.getHomeworkCompletionReport()
    }

    onClickBack = () => {
        this.props.delegate && this.props.delegate.hideReport && this.props.delegate.hideReport()
    }

    getHomeworkCompletionReport(payload = {}) {

        this.setState({ isLoading: true })

        if (payload.page) payload.page = 1
        if (payload.page) payload.limit = this.limit
        // payload.type = this.props.match.params.type
        payload.type = this.props.type


        // if (this.props.match.params.homeworkId) {
        //     payload.homeworkId = this.props.match.params.homeworkId
        // }

        if (this.props.selectedItem) {
            payload.homeworkId = this.props.selectedItem._id
        }

        HomeworkApi.getHomeworkCompletionReport(payload)
            .then(response => {

                console.log("response", response)
                this.setState({
                    completedStudents: response.completedStudents,
                    inProgressStudents: response.inProgressStudents,
                    notCompletedStudents: response.notCompletedStudents, isLoading: false
                })

            }).catch(err => {
            })
    }

    renderBreadcrumb = () => {
        return (
            <div className='breadcrumb-1'>
                <span>{`${this.props.selectedItem?.class} >`}</span>
                <span className='pl-2'>{`${this.props.selectedItem?.section || ""} >`}</span>
                <span className='pl-2'>{`${this.props.selectedItem?.chapter ? this.props.selectedItem?.chapter : this.props.selectedItem?.chapters ? this.props.selectedItem?.chapters[0].title : ''} >`}</span>
                <span className='pl-2'>{this.getDate(this.props.selectedItem?.createdDateTimestamp)}</span>
            </div>
        )
    }

    getDate = (timeStamp, getYear) => {

        let dateFormat = new Date(timeStamp).toDateString();

        let date = dateFormat.split(" ")[2];

        let month = dateFormat.split(" ")[1];

        let year = dateFormat.split(" ")[3];

        if (getYear) {
            return date + " " + month + " " + year;
        } else {
            return date + " " + month;
        }
    }


    render() {
        return (
            <>
                {this.state.isLoading && <div ><Loading> </Loading></div>}
                <div className='completion-report-1'>

                    {/* <div className='container-1'>
                        <div className='mb-3 item1' >
                            <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                        </div>
                        <div className='item-2'>
                            <span className='screen-title title-center my-5'>Homework Completion Report</span>
                        </div>
                    </div>

                    <span>{this.renderBreadcrumb()}</span> */}
                    <div className='mb-3 item1' >
                        <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                    </div>
                    <div className='d-flex align-items-center justify-content-between header-report-card'>
                        <div className='d-flex align-items-center'>
                            <div>
                                <img className='circle-image' src={getImageSource(ImageConstants.COMPLETION_DETAIL_REPORT)} />
                            </div>
                            <div className='ml-2'>
                                <div className=''>
                                    {/* <span className='screen-title-1 title-center'>{`${this.props.selectedItem.type === 'STANDARD' || this.props.selectedItem.type === 'ADAPTIVE' ? 'Homework' : 'Classwork'} Completion Report`}</span> */}
                                    <span className='screen-title-1 title-center'>{`Completion Report`}</span>

                                    <span>{this.renderBreadcrumb()}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="pl-5 pt-4 wrapper">
                        <div class="report-card border-green d-inline-block">
                            <div class="report-header background-green"><div>Completed ({this.state.completedStudents && this.state.completedStudents.length ? this.state.completedStudents.length : 0})</div></div>
                            <div className="report-body">
                                {
                                    this.state.completedStudents && this.state.completedStudents.length ? this.state.completedStudents.map(student => (
                                        <div className="py-3">
                                            <div className="flex">
                                                {/* <div className="profile-avatar text-center mr-2 d-inline-block">
                                                    <div className="row justify-content-center">
                                                        {student.image ? <img className="" alt="img" src={`${student.basePath}${student.image}`} />
                                                            :
                                                            <img className="" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                                    </div>
                                                </div> */}
                                                <div className="pl-2 d-inline-block">
                                                    <div className="student-name">{student?.name}</div>
                                                    <div className="student-mark">Completed on {this.getDate(student.finishTime)}</div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                        :
                                        <div className="no-data text-center">
                                            <img className="" src={getImageSource(ImageConstants.NO_DATA)} />
                                            <div className="empty">This is Empty</div>
                                            <div className="no-student">No Student in this bucket</div>
                                        </div>
                                }

                            </div>
                        </div>
                        {
                            this.props.type != 'CLICKER_PRACTICE_STANDARD' ?
                                <div class="report-card border-green d-inline-block ml-4">
                                    <div class="report-header background-green"><div>In Progress ({this.state.inProgressStudents && this.state.inProgressStudents.length ? this.state.inProgressStudents.length : 0})</div></div>
                                    <div className="report-body">
                                        {
                                            this.state.inProgressStudents && this.state.inProgressStudents.length ? this.state.inProgressStudents.map(student => (
                                                <div className="py-3">
                                                    <div className="flex">
                                                        {/* <div className="profile-avatar text-center mr-2 d-inline-block">
                                                            <div className="row justify-content-center">
                                                                {student.image ? <img className="" alt="img" src={`${student.basePath}${student.image}`} />
                                                                    :
                                                                    <img className="" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                                            </div>
                                                        </div> */}
                                                        <div className="pl-2 d-inline-block">
                                                            <div className="student-name">{student?.name}</div>
                                                            <div className="student-mark">Started on {this.getDate(student.startTime)}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                                :
                                                <div className="no-data text-center">
                                                    <img className="" src={getImageSource(ImageConstants.NO_DATA)} />
                                                    <div className="empty">This is Empty</div>
                                                    <div className="no-student">No Student in this bucket</div>
                                                </div>
                                        }

                                    </div>
                                </div>
                                :
                                 <div class="report-card border-green d-inline-block ml-4">
                                    <div class="report-header background-green"><div>Inprogress ({this.state.inProgressStudents && this.state.inProgressStudents.length ? this.state.inProgressStudents.length : 0})</div></div>
                                    <div className="report-body">
                                        {
                                            this.state.inProgressStudents && this.state.inProgressStudents.length ? this.state.inProgressStudents.map(student => (
                                                <div className="py-3">
                                                    <div className="flex">
                                                        {/* <div className="profile-avatar text-center mr-2 d-inline-block">
                                                            <div className="row justify-content-center">
                                                                {student.image ? <img className="" alt="img" src={`${student.basePath}${student.image}`} />
                                                                    :
                                                                    <img className="" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                                            </div>
                                                        </div> */}
                                                        <div className="pl-2 d-inline-block">
                                                            <div className="student-name">{student?.name}</div>
                                                            <div className="student-mark">Started on {this.getDate(student.startTime)}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                                :
                                                <div className="no-data text-center">
                                                    <img className="" src={getImageSource(ImageConstants.NO_DATA)} />
                                                    <div className="empty">This is Empty</div>
                                                    <div className="no-student">No Student in this bucket</div>
                                                </div>
                                        }

                                    </div>
                                </div>

                        }
                       
                        <div className="report-card border-red d-inline-block ml-4">
                            <div class="">
                                <div class="report-header background-red"><div>Not Completed ({this.state.notCompletedStudents && this.state.notCompletedStudents.length ? this.state.notCompletedStudents.length : 0})</div></div>
                                <div className="report-body">
                                    {
                                        this.state.notCompletedStudents && this.state.notCompletedStudents.length ? this.state.notCompletedStudents.map(student => (
                                            <div className="py-3">
                                                <div className="flex">
                                                    {/* <div className="profile-avatar text-center mr-2 d-inline-block">
                                                        <div className="row justify-content-center">
                                                            {student.image ? <img className="" alt="img" src={`${student.basePath}${student.image}`} />
                                                                :
                                                                <img className="" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                                        </div>
                                                    </div> */}
                                                    <div className="pl-2 d-inline-block">
                                                        <div className="student-name">{student?.name}</div>
                                                        {/* <div className="student-mark">Marks: {student.mark}</div> */}
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                            :
                                            <div className="no-data text-center">
                                                <img className="" src={getImageSource(ImageConstants.NO_DATA)} />
                                                <div className="empty">This is Empty</div>
                                                <div className="no-student">No Student in this bucket</div>
                                            </div>
                                    }

                                </div>
                            </div>
                        </div>
                    </div ></div>
            </>
        );
    }
}

export default withRouter(CompletionReport);